/**
 * created by tian ruo jun
 同步发布其他媒体
 *
 */
import React, {Component} from 'react';
import {Icon, Input, Tree, DatePicker, Select, message} from 'antd'
import SwitchBounced from "../../components/switchBounced/SwitchBounced"
import '../EditorPublishInformation.css'
import Concurrently from "../concurrently/Concurrently";
import BaseComponent from "../../../../base/BaseComponent";
const {TreeNode} = Tree;
const getNodesUrl = "/cm-sites-pms/contribute/nodes";
const collectUrl = "/cm-sites-pms/contribute/collect";
const cancelCollectionUrl = "/cm-sites-pms/contribute/cancel";
export default class Release extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute:true,
            properties: true,
            orso: true,
            switchShow: false,
            publishInformation: {
                currentColumn: [],//当前栏目
                numerical: '',//重要性
                location: '',//显示位置
                frequency: '',//点击次数
                accretion: [],//同步数据
            },
            treeData: [
                {
                    title: '百家号',
                    key: '0-0',
                    children: [
                        {
                            title: '这是一个百家号名称',
                            key: '0-0-0',
                        },
                        {
                            title: '头条号',
                            key: '0-0-1',
                            children: [
                                {title: '头条号-1', key: '0-0-1-0'},
                                {title: '头条号-2', key: '0-0-1-1'},
                                {title: '头条号-3', key: '0-0-1-2'},
                            ],
                        },

                    ],
                },
            ]
        }
    }

    componentWillMount() {
        // this.getNodes()
    }

    componentDidMount() {
    }

    getCheckedKeys = () => {
        return this.state.checkedKeys
    }

    setCheckedKeys = (checkedKeys) => {
        this.setState({
            checkedKeys
        })
    }

    getNodes = () => {
        this.request({
            url:getNodesUrl,
            callBack:(res)=>{
                let treeData = [];
                if(res){
                    treeData=res;
                }
                this.setState({treeData})
            },
            errorCallBack:(e)=>{
                this.setState({treeData:[]})
            }
        })
    };

    render() {
        const {synchronize, treeData} = this.state;
        return (
            <>
                <div className="synchronize">
                    <div className="overstriking">同步到</div>
                    <div><Icon className="lineIcon" type={synchronize ? "down" : "up"}
                               onClick={this.synchronizeTree}/>
                    </div>
                </div>
                {synchronize ?
                    <div>
                        <Tree
                            showIcon
                            checkable
                            defaultExpandedKeys={['0-0-0', '0-0-1']}//默认展开指定的树节点
                            defaultSelectedKeys={['0-0-1-1']}//默认选中的树节点
                            defaultCheckedKeys={['0-0-1-1']}//默认选中复选框的树节点
                            onSelect={this.onSelect}
                            onCheck={this.onCheck}
                        >
                            {this.renderTreeNodes(treeData)}
                        </Tree>
                    </div> : ''
                }
            </>
        )
    }

    synchronizeTree = () => {
        const {synchronize} = this.state;
        this.setState({
            synchronize: !synchronize,
        })
    }

    renderTreeNodes = data =>
        data.map(item => {
            if (item.children) {
                return (
                    <TreeNode icon={<Icon type="folder-open"/>} title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode icon={<Icon type="file-text"/>} key={item.key} {...item} />;
        });

    onSelect = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
    };

    onCheck = (checkedKeys, info) => {
        const titleeName = [];
        info.checkedNodes.forEach(item => {
            titleeName.push(item.props.title);
        })
        console.log('onCheck', checkedKeys, info);
        this.setState({
            titleeName: titleeName
        })
    };

}